export const escapeDate = "YYYY-MM-DDTHH:mm:ss[Z]";

export const FULL_DATE = "DD/MM/YYYY";

export const YEAR = "YYYY";
